import React, { Component } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import NProgress from "nprogress";
import { allFlattenRoutes as routes } from "./index";
import { initMenu, changeActiveMenuFromLocation } from "~/redux/actions";
import { isUserAuthenticated } from "~/helpers/authUtils";

import * as layoutConstants from "~/constants/layout";

// All layouts/containers
import AuthLayout from "~/layouts/Auth";
import VerticalLayout from "~/layouts/Vertical";
import HorizontalLayout from "~/layouts/Horizontal";
import DetachedLayout from "~/layouts/Detached";
import PrivateRoute from "./PrivateRoute";
import DynamicPetaPages from "~/pages/peta/dynamic-peta";
import PetaBidangPages from "~/pages/peta/peta-bidang";
import AccessBlocked from "~/pages/error/AccessBlocked";
import ErrorPageNotFound from "~/pages/error/PageNotFound";

class Routes extends Component {
  // returns the layout

  getLayout = () => {
    if (!isUserAuthenticated()) return AuthLayout;

    let layoutCls = VerticalLayout;

    switch (this.props.layout.layoutType) {
      case layoutConstants.LAYOUT_HORIZONTAL:
        layoutCls = HorizontalLayout;
        break;
      case layoutConstants.LAYOUT_DETACHED:
        layoutCls = DetachedLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  };

  shouldComponentUpdate(nextProps, nextState) {
    let oldLayout = { ...this.props.layout };
    delete oldLayout.showRightSidebar;
    let newLayout = { ...nextProps.layout };
    delete newLayout.showRightSidebar;

    return (
      JSON.stringify(oldLayout) !== JSON.stringify(newLayout) ||
      JSON.stringify(this.props.user) !== JSON.stringify(nextProps.user)
    );
  }

  componentWillUnmount() {
    // NProgress.start();
  }

  componentDidMount() {
    // NProgress.done();
  }

  render() {
    const Layout = this.getLayout(); // rendering the router with layout

    return (
      <BrowserRouter>
        <Switch>
          <PrivateRoute path="/peta" exact component={DynamicPetaPages} />
          <PrivateRoute path="/peta-bidang" exact component={PetaBidangPages} />
          <Route path="/akses-ditolak" exact component={AccessBlocked} />

          <Route path="/user">
            <Layout {...this.props}>
              <Switch>
                {routes?.map((route, index) => {
                  return (
                    route.component && (
                      <route.route
                        key={index}
                        path={route.path}
                        roles={route.roles}
                        exact={route.exact}
                        component={route.component}
                      />
                    )
                  );
                })}
              </Switch>
            </Layout>
          </Route>
          <Route
            path="/404"
            exact
            render={() => <ErrorPageNotFound withPageTitle={false} />}
          />

          <Route path="*" render={() => <Redirect to="/404" />} />
        </Switch>
        <Route
          path="/"
          exact
          render={() => <Redirect to="/user/dashboard" />}
        />
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
    desa: state.Auth.desa,
    user: state.Auth.user,
    menu: state.AppMenu.menuItems,
  };
};

export default connect(mapStateToProps, {
  initMenu,
  changeActiveMenuFromLocation,
})(Routes);
